import wx from './jweixin1.6.0.js';
import http from './http'
import utils from './utils'

class WxPay {
	constructor(){
		this.init()
	}
	init(){
		if(utils.browserChecker.isWx()){
			http.get('user/getShareSign', {
				params: {
					appid: 'wxed3c0977b2b75767',
					url: encodeURIComponent(window.location.href.split('#')[0])
				}
			}).then(res => {
				let data = res.data
				wx.config({
					debug: false,
					appId: 'wxed3c0977b2b75767',
					timestamp: data.timestamp,
					nonceStr: data.noncestr,
					signature: data.signature,
					jsApiList: ['checkJsApi', 'chooseWXPay']
				})
			})
		}
	}
	pay(payload={}, callback){
		let option = {
			timestamp: payload.timeStamp,
			nonceStr: payload.nonceStr,
			package: payload.package,
			signType: payload.signType,
			paySign: payload.paySign,
			success: callback
		}
		wx.chooseWXPay(option)
	}
}

export default WxPay